import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BreadcrumbService } from './breadcrumb.service';

/**
 * Non-blocking drill-down breadcrumb (FR-028): ordered list, ancestors are
 * routerLink anchors, the last segment is text with aria-current="page".
 */
@Component({
  selector: 'app-breadcrumb',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  template: `
    <nav aria-label="Breadcrumb">
      <ol class="breadcrumb-list">
        @for (segment of segments(); track segment.url) {
          <li>
            @if (segment.isCurrent) {
              <span aria-current="page">{{ segment.label }}</span>
            } @else {
              <a [routerLink]="segment.url">{{ segment.label }}</a>
            }
          </li>
        }
      </ol>
    </nav>
  `,
  styles: `
    .breadcrumb-list {
      display: flex;
      align-items: center;
      gap: var(--space-sm);
      list-style: none;
      margin: 0;
      padding: 0;
      font-size: var(--font-size-sm);
    }
    li + li::before {
      content: '/';
      margin-right: var(--space-sm);
      color: var(--color-text-muted);
    }
    a {
      color: var(--color-primary);
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
    [aria-current='page'] {
      color: var(--color-text-muted);
    }
  `,
})
export class BreadcrumbComponent {
  private readonly breadcrumbs = inject(BreadcrumbService);
  protected readonly segments = this.breadcrumbs.segments;
}
